import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuillEditorService } from '../../services/quill/quill.service';

@Component({
    selector: 'topo-text-edit',
    templateUrl: './text-edit.component.html',
    styleUrls: ['./text-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextEditComponent implements OnInit, OnDestroy {
  @Output() textUpdated = new EventEmitter<string>();
  @Output() cancelText = new EventEmitter<void>();
  @Input() backgroundCanClose: boolean = true;
  @Input() set isActive(value: boolean) {
    this._isActive = value;
    this._isActive$.next(value);
  }
  get isActive(): boolean {
    return this._isActive;
  }
  _isActive = false;
  _isActive$: Subject<boolean> = new Subject<boolean>();

  destroy$ = new Subject<void>();
  @Input() title: string;
  @Input() set value(value: string) {
    if (!value) {
      value = '';
    }

    this._value = value;
  }
  _value: string;

  constructor(private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._isActive$.pipe(takeUntil(this.destroy$)).subscribe(isActive => {
      this.changeDetector.markForCheck();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancelClick(): void {
    this.cancelText.emit();
  }

  saveClick(): void {
    this.textUpdated.emit(this._value);
  }
}
